const NotFoundConstantsEN = {
  notFoundMessage: 'The page you requested could not be found',
};
export default NotFoundConstantsEN;
